import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Dashboard.mock.json'
import constructRequestData from '../../constructRequestData'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

const identity = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'get /hero-banners': 200,
    // 'get /promos*': 200,
    // 'get /promos/*': 422,
    // 'get /events*': 422,
    // 'get /events/*': 422,
    // 'get /events*': 422,
    // 'get /display/explore*': 422,
  })
}

export const getPasyalArticles = (limit = '') => {}
export const getHeroBanner = () =>
  client({
    method: 'get',
    url: '/hero-banner',
  })

export const getHeroBanners = () =>
  client({
    method: 'get',
    url: '/hero-banners',
  })

export const getFeatureStatus = () =>
  identity({
    method: 'get',
    url: '/feature-status',
  })

export const getAllMerchants = (limit = '') =>
  client({
    method: 'get',
    url: `/display/explore?limit=${encodeURIComponent(
      limit,
    )}&isFilterOutNoImage=true`,
  })

export const getUserAgreementStatus = accessToken =>
  identity({
    method: 'get',
    url: `/user-agreement`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const postUserAgreement = (accessToken, values) =>
  identity({
    method: 'post',
    url: `/user-agreement`,
    data: constructRequestData({
      ...values,
    }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      // 'X-Device-Id': generateDeviceId(),
    },
  })

export const postNewsletterSubscription = ({ emailAddress }) => {
  return identity({
    method: 'post',
    url: '/newsletter/subscribe',
    data: constructRequestData({ emailAddress }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })
}
